import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../../constants';
import { authFetch } from '../../helpers/apiActions/authFetch';

export function useRetrieveProfileInfo() {
    const url = `${API_BASE_URL}/users/me?populate=*`;
    const [profileInfo, setProfileInfo] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        async function getProfileInfo(url) {
            try {
                setIsLoading(true);
                setIsError(false);

                const response = await authFetch(url);
                const userData = await response.json();

                setProfileInfo(userData);
            } catch(error) {
                console.log(error);
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        }

        getProfileInfo(url);
    }, [url]);
    return { profileInfo, isLoading, isError};
}

export default useRetrieveProfileInfo;